import React, { useContext } from "react";
import { ForecastReportsContext } from "..";
import { NoReport } from "./NoReport";
import { ReportCard } from "./ReportCard";

export const Report = () => {
  const { employeeId } = useContext(ForecastReportsContext);
  return <div>{employeeId ? <ReportCard /> : <NoReport />}</div>;
};
